var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 2.77734C6.28498 2.77734 2.521 6.57441 2.521 11.2565C2.521 11.6362 2.21319 11.944 1.8335 11.944C1.4538 11.944 1.146 11.6362 1.146 11.2565C1.146 5.81861 5.52201 1.40234 11.0002 1.40234C14.2614 1.40234 16.7035 2.76451 18.3167 4.11025C18.7672 4.48602 19.1546 4.8617 19.4793 5.20836V2.60318C19.4793 2.22348 19.7871 1.91568 20.1668 1.91568C20.5465 1.91568 20.8543 2.22348 20.8543 2.60318V7.18651C20.8543 7.56621 20.5465 7.87401 20.1668 7.87401H16.0968C15.7171 7.87401 15.4093 7.56621 15.4093 7.18651C15.4093 6.80681 15.7171 6.49901 16.0968 6.49901H18.7912C18.449 6.10245 17.997 5.63419 17.4359 5.1661C15.9943 3.96351 13.8531 2.77734 11.0002 2.77734ZM20.1668 10.569C20.5465 10.569 20.8543 10.8768 20.8543 11.2565C20.8543 16.6962 16.4399 21.1107 11.0002 21.1107C8.23141 21.1107 6.03594 19.7172 4.5662 18.3841C4.17607 18.0302 3.8327 17.6768 3.5385 17.3482V19.9098C3.5385 20.2895 3.23069 20.5973 2.851 20.5973C2.4713 20.5973 2.1635 20.2895 2.1635 19.9098V15.3265C2.1635 14.9468 2.4713 14.639 2.851 14.639H6.99433C7.37403 14.639 7.68183 14.9468 7.68183 15.3265C7.68183 15.7062 7.37403 16.014 6.99433 16.014H4.205C4.53573 16.4161 4.96705 16.8913 5.48996 17.3656C6.8298 18.5809 8.70892 19.7357 11.0002 19.7357C15.6805 19.7357 19.4793 15.9368 19.4793 11.2565C19.4793 10.8768 19.7871 10.569 20.1668 10.569Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2);
export default __webpack_public_path__ + "static/media/refresh-2.7c6103cc.svg";
export { ForwardRef as ReactComponent };